import { createSlice } from '@reduxjs/toolkit';
import copy from 'copy-to-clipboard';
import { toast } from 'react-toastify';
const contextSlice = createSlice({
    name: 'context',
    initialState: {

        token: localStorage.getItem('token'),
        tokenType: localStorage.getItem('loginType') || 'standard',
        permissions: localStorage.getItem('loginType') === 'ldap' && localStorage.getItem('token')?.split('.')[1] ? JSON.parse(atob(localStorage.getItem('token')?.split('.')[1]))?.permission : {},
        homeActivityRef: null,
        expiryTime: null,
        countdown: 900,
        toastMessage: {
            type: 'success',
            message: ''
        },
        zipValidationMessage: {},
        deleteUpdateYes: '',
        deleteUpdateTag: '',
        search: '',
        addEditDeleteTag: '',
        currentHomeModalKey: '',
        currentUserId: '',

        currentPage: 1,
        currentThemePage: 1,
        totalPage: 1,
        perPage: 15,

        childModalCurrentPage: 1,
        childModalTotalPage: 1,
        childModalPerPage: 8,

        toggleSidebar: false,
        confirmationModalShow: false,
        confirmationModalShowData: {},
        isLoading: false,
        isModalLoading: false,
        isSubModalLoading: false,
        open: false,
        openModal: false,
        openPreview: false,

        currentPageData: [],
        encodingString: [],
        currentModalTableData: [],
        childModalTableData: [],
        homeScreenSectionData: [],

        homeScreenData: [],
        homeTableData: [],
        checkedValues: [],
        selectedOptions: [],
        range: {},
        filterDate: '',
        copy: false,

        multiCountry: [],
        multiRegion: [],

        formData: {},
        imgObj: {},
        deleteUpdateItem: {},
        filterDropdown: {},
        historyFilterDropdown: { section: 'themelists' },
        isLoadMore: "",

        openmod: false,

        childFormData: {},
        childOpen: false,
        childReportOpen: false,
        imageHeightWidth: {},

        saveMedia: 0,
        eventDate: [],
        min: 0,
        max: 1000,
        configData: []
    },
    reducers: {
        setCurrentPageChildData: (state, action) => {
            state.currentPageChildData = action.payload;
        },
        setIsChildLoading: (state, action) => {
            state.isChildLoading = action.payload;
        },
        setSortData: (state, action) => {
            state.sortData = action.payload;
        },
        setIsAscending: (state, action) => {
            state.isAscending = action.payload;
        },
        setSaveMedia: (state, action) => {
            state.saveMedia = action.payload;
        },
        setHomeActivityRef: (state, action) => {
            state.homeActivityRef = action.payload;
        },
        decrementCountdown: (state) => {
            state.countdown -= 1;
        },
        resetCountdown: (state) => {
            state.countdown = 900; // Reset to 15 minutes
        },
        resetTimer: (state) => {
            state.countdown = 900; // Reset to 5 minutes
        },
        setToken: (state, action) => {
            state.token = action.payload;
        },
        setPermissions: (state, action) => {
            state.permissions = action.payload
        },
        setTokenType: (state, action) => {
            state.tokenType = action.payload
        },
        setExpiryTime: (state, action) => {
            state.expiryTime = Date.now() + (process.env.REACT_APP_SESSION_TIMEOUT_DURATION * 60 * 1000);   // stored in miliseconds
        },
        setToastMessage: (state, action) => {
            state.toastMessage = action.payload;
        },
        setDeleteUpdateYes: (state, action) => {
            state.deleteUpdateYes = action.payload;
        },
        setDeleteUpdateTag: (state, action) => {
            state.deleteUpdateTag = action.payload;
        },
        setSearch: (state, action) => {
            state.search = action.payload;
        },
        setAddEditDeleteTag: (state, action) => {
            state.addEditDeleteTag = action.payload;
        },
        setCurrentHomeModalKey: (state, action) => {
            state.currentHomeModalKey = action.payload
        },
        setCurrentUserId: (state, action) => {
            state.currentUserId = action.payload;
        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload && action.payload === 0 ? 1 : action.payload;
        },
        setCurrentThemePage: (state, action) => {
            state.currentThemePage = action.payload;
        },
        setTotalPage: (state, action) => {
            state.totalPage = action.payload;
        },
        setPerPage: (state, action) => {
            state.perPage = action.payload == 0 ? 15 : action.payload;
        },
        setChildModalCurrentPage: (state, action) => {
            state.childModalCurrentPage = action.payload;
        },
        setchildModalTotalPage: (state, action) => {
            state.childModalTotalPage = action.payload;
        },
        setChildModalPerPage: (state, action) => {
            state.childModalPerPage = action.payload;
        },
        setToggleSidebar: (state, action) => {
            state.toggleSidebar = action.payload;
        },
        setConfirmationModalShow: (state, action) => {
            state.confirmationModalShow = action.payload;
        },
        setNotificationData: (state, action) => {
            state.confirmationModalShowData = action.payload;
        },
        setIsLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setIsModalLoading: (state, action) => {
            state.isModalLoading = action.payload;
        },
        setIsSubModalLoading: (state, action) => {
            state.isSubModalLoading = action.payload;
        },
        setOpen: (state, action) => {
            state.open = action.payload;
        },
        setOpenModal: (state, action) => {
            state.openModal = action.payload;
        },
        setOpenPreview: (state, action) => {
            state.openPreview = action.payload;
        },
        setCurrentPageData: (state, action) => {
            state.currentPageData = action.payload;
        },
        setEncodingString: (state, action) => {
            state.encodingString = action.payload;
        },
        setCurrentModalTableData: (state, action) => {
            state.currentModalTableData = action.payload;
        },
        setChildModalTableData: (state, action) => {
            state.childModalTableData = action.payload;
        },
        setHomeScreenSectionData: (state, action) => {
            state.homeScreenSectionData = action.payload;
        },
        setHomeScreenData: (state, action) => {
            state.homeScreenData = action.payload;
        },
        setHomeTableData: (state, action) => {
            state.homeTableData = action.payload;
        },
        setCopy: (state, action) => {
            state.copy = action.payload;
        },
        setCheckedValues: (state, action) => {
            state.checkedValues = action.payload
        },
        setSelectedOptions: (state, action) => {
            state.selectedOptions = action.payload
        },
        setRange: (state, action) => {
            state.range = action.payload
        },
        setFilterDate: (state, action) => {
            state.filterDate = action.payload
        },
        setMultiCountry: (state, action) => {
            state.multiCountry = action.payload
        },
        setMultiRegion: (state, action) => {
            state.multiRegion = action.payload
        },
        setFormData: (state, action) => {
            state.formData = action.payload
        },
        setImgObj: (state, action) => {
            state.imgObj = { ...state.imgObj, ...action.payload }
        },
        setDeleteUpdateItem: (state, action) => {
            state.deleteUpdateItem = action.payload
        },
        setFilterDropdown: (state, action) => {
            state.filterDropdown = action.payload
        },
        setHistoryFilterDropdown: (state, action) => {
            state.historyFilterDropdown = action.payload === undefined ? { section: 'themelists' } : action.payload;
        },
        setIsLoadMore: (state, action) => {
            state.isLoadMore = action.payload
        },
        setOpenMod: (state, action) => {
            state.openmod = action.payload
        },
        setChildFormData: (state, action) => {
            state.childFormData = action.payload
        },
        setChildOpen: (state, action) => {
            state.childOpen = action.payload
        },
        setReportChildOpen: (state, action) => {
            state.childReportOpen = action.payload
        },
        setImageHeightWidth: (state, action) => {
            state.imageHeightWidth = action.payload
        },
        setZipValidationMessage: (state, action) => {
            state.zipValidationMessage = action.payload;
        },
        // Config Store
        setConfigData: (state, action) => {
            state.configData = action.payload;
        },
        //--------------------------------------------------------------------
        handleCopyToClipboard: (state, action) => {
            navigator.clipboard.writeText(action.payload)
            state.copy = true;
            toast.success("Copied..")

        },
        handlePermissions: (state, action) => {
            state.permissions = action.payload
        },
        handleChildOpen: (state) => {
            state.childOpen = !state.childOpen;
        },
        handleChildClose: (state) => {
            state.childOpen = false;
            state.childFormData = {};
            state.deleteUpdateYes = '';
            state.deleteUpdateTag = '';
            state.deleteUpdateItem = {};
            state.imgObj = {};
            state.checkedValues = [];
            state.multiCountry = [];
            state.multiRegion = [];
        },

        handleReportChildOpen: (state) => {
            state.childReportOpen = true
        },

        handleReportChildClose: (state) => {
            state.childReportOpen = false;
        },

        handleChildChange: (state, action) => {
            if (action.payload.name === 'country' || action.payload.name === 'region') {
                state.childFormData[action.payload.name] = action.payload.value;
                state.formData[action.payload.name] = action.payload.value;
            } else {
                state.childFormData[action.payload.name] = action.payload.value;
                state.formData[action.payload.name] = action.payload.value;
            }
        },

        handleChildSwitch: (state, action) => {
            state.childFormData[action.payload.name] = !state.childFormData[action.payload.name];
        },

        handleOpenbtn: (state) => {
            state.openmod = true;
        },
        handleClosebtn: (state) => {
            state.openmod = false;
        },

        handleCopyData: (state, action) => {
            const { tag, string } = action.payload;
            copy(string);
            toast.success(`${tag} Copied.`);
        },

        handleFilterChange: (state, action) => {
            const { name, value } = action.payload;
            state.filterDropdown = { ...state.filterDropdown, [name]: value === 'true' ? true : value === 'false' ? false : '' };
            state.checkedValues = [];
            state.currentPage = 1;
        },

        handleCheckboxChange: (state, action) => {
            const { value } = action.payload;
            if (state.checkedValues.includes(value)) {
                state.checkedValues = state.checkedValues.filter((val) => val !== value);
            } else {
                state.checkedValues.push(value);
            }
        },

        handleSelectAll: (state, action) => {
            const { checked } = action.payload;
            const path = window.location.href.split('/').pop();
            const data = path === 'homescreen' ? state.homeScreenSectionData : state.currentPageData;
            state.checkedValues = checked ? [...data?.map(_ele => _ele._id)] : []
        },
        handleDeleteAll: (state, action) => {
            state.deleteUpdateYes = action.payload;
            state.deleteUpdateItem = { id: state.checkedValues }
            state.confirmationModalShow = !state.confirmationModalShow;
        },
        handleChange: (state, action) => {
            const { name, value, type } = action.payload;
            if (value.trim() === "") {
                const trimmedValue = value.trim();
                state.deleteUpdateItem[name] = trimmedValue;
                state.formData[name] = trimmedValue;
                return;
            }
            state.deleteUpdateItem[name] = value;
            state.formData[name] = value;
        },

        handleLogout: () => {
            localStorage.clear();
            toast.success(`Logout Successfully.`);
            window.location.reload();
        },

        handleSwitch: (state, action) => {
            state.formData[action.payload.name] = state.formData[action.payload.name] ? false : true;
        },

        handleSwitchUpdate: (state, action) => {
            const { id, name, checked } = action.payload
            state.deleteUpdateItem = { id: id, [name]: !checked ? false : true }
            state.confirmationModalShow = !state.confirmationModalShow
        },

        handleOpen: (state) => {
            state.open = true;
        },

        handleClose: (state, action) => {
            state.open = false;
            state.openPreview = false;
            state.deleteUpdateYes = '';
            state.deleteUpdateTag = '';
            state.addEditDeleteTag = '';
            state.currentHomeModalKey = '';
            state.deleteUpdateItem = {};
            state.formData = {};
            state.childFormData = {};
            state.imgObj = {};
            state.checkedValues = [];
            state.multiCountry = [];
            state.multiRegion = [];
            state.saveMedia = 0;
        },

        handleFileInput: (state, action) => {
            const { name, files, width, height } = action.payload

            if (name == "bigPreviewStickerStore" || name.includes("video") || name.includes("videoPreview") || name.includes("faqImages")) {
                state['formData'] = { ...state.formData, [name]: files }
            } else {
                const inputFile = files[0];
                if (['themeZip', 'keyZip', 'stickerZip', 'lenseZipxhdpi'].includes(name)) {
                    if (!inputFile.name.match(/\.(zip)$/i)) {
                        state.toastMessage = { type: 'error', message: 'Please select valid zip.' }
                        return;
                    }
                } else if (['fontFile'].includes(name)) {
                    if (!inputFile.name.match(/\.(ttf|otf|TTF|OTF)$/)) {
                        state.toastMessage = { type: 'error', message: 'Please select valid font file.' }
                        return;
                    }
                } else if (['mp3file'].includes(name)) {
                    if (!inputFile.name.match(/\.(mp3)$/)) {
                        state.toastMessage = { type: 'error', message: 'Please select valid sound file.' }
                        return;
                    }
                } else if (['categoryBinFile'].includes(name)) {
                    if (!inputFile.name.match(/\.(bin)$/)) {
                        state.toastMessage = { type: 'error', message: 'Please select valid bin file.' }
                        return;
                    }
                }

                state.formData = { ...state.formData, [name]: files[0] };
                state.imgObj = { ...state.imgObj, [name]: URL.createObjectURL(files[0]) }
            }
        },

        handleSelectMultiCountry: (state, action) => {
            const { selectName, selectedArray } = action.payload
            if (selectedArray?.length > 0) {
                selectedArray.map(_ele => {
                    let multiSelectAry = [].slice.call(selectedArray).map(item => item._id);
                    if (selectName === 'country') {
                        state.multiCountry = selectedArray
                    }
                    if (state.childOpen) {
                        state.childFormData = { ...state.childFormData, [_ele.name]: multiSelectAry }
                    } else {
                        state.formData = { ...state.formData, [_ele.name]: multiSelectAry }
                    }
                })
            } else {
                if (selectName === 'country') {
                    state.multiCountry = []
                }
                if (state.childOpen) {
                    state.childFormData = { ...state.childFormData, [selectName]: [] }
                } else {
                    state.formData = { ...state.formData, [selectName]: [] }
                }
            }
        },
        handleSelectMultiColor: (state, action) => {
            const { selectName, selectedArray } = action.payload
            if (selectedArray?.length > 0) {
                selectedArray.map(_ele => {
                    let multiSelectAry = [].slice.call(selectedArray).map(item => item._id);
                    if (selectName === 'color') {
                        state.multiColor = selectedArray
                    }
                    if (state.childOpen) {
                        state.childFormData = { ...state.childFormData, [_ele.name]: multiSelectAry }
                    } else {
                        state.formData = { ...state.formData, [_ele.name]: multiSelectAry }
                    }
                })
            } else {
                if (selectName === 'color') {
                    state.multiColor = []
                }
                if (state.childOpen) {
                    state.childFormData = { ...state.childFormData, [selectName]: [] }
                } else {
                    state.formData = { ...state.formData, [selectName]: [] }
                }
            }
        },
        handleReset: (state, action) => {
            state.perPage = 15
            state.currentPage = 1
            state.totalPage = 1
            state.search = ''
            state.sortData = ''
            state.isAscending = false
            state.filterDropdown = {}
            state.currentPageData = []
        },
        truncateString: (state, action) => {
            const { text, maxLength } = action.payload;
            if (text.length <= maxLength) {
                return text;
            }
            const truncationLength = maxLength // Math.floor((maxLength - 3) / 2);
            const start = text.slice(0, truncationLength);
            const end = text.slice(text.length - truncationLength);
            return `${start}...${end}`;
        },
        setEventDate: (state, action) => {
            state.eventDate = action.payload
        },
        handleImportClose: (state, action) => {
            state.open = false;
            state.openPreview = false;
            state.deleteUpdateYes = '';
            state.deleteUpdateTag = '';
            state.addEditDeleteTag = '';
        },
        setMin: (state, action) => {
            state.min = action.payload
        },
        setMax: (state, action) => {
            state.max = action.payload
        },
    }
});

// Export your actions
export const {
    setCurrentPageChildData,
    setIsChildLoading,
    setSortData,
    setIsAscending,
    setSaveMedia,
    setHomeActivityRef,
    setToken,
    decrementCountdown,
    resetCountdown,
    resetTimer,
    setExpiryTime,
    setToastMessage,
    setDeleteUpdateYes,
    setDeleteUpdateTag,
    setSearch,
    setAddEditDeleteTag,
    setCurrentHomeModalKey,
    setCurrentUserId,
    setCurrentPage,
    setCurrentThemePage,
    setTotalPage,
    setPerPage,
    setChildModalCurrentPage,
    setchildModalTotalPage,
    setChildModalPerPage,
    setToggleSidebar,
    setConfirmationModalShow,
    setNotificationData,
    setIsLoading,
    setIsModalLoading,
    setIsSubModalLoading,
    setOpen,
    setOpenModal,
    setCurrentPageData,
    setFeedbackDropdownlist,
    setEncodingString,
    setCurrentModalTableData,
    setChildModalTableData,
    setHomeScreenSectionData,
    setHomeScreenData,
    setHomeTableData,
    setCheckedValues,
    setSelectedOptions,
    setRange,
    setFilterDate,
    setMultiCountry,
    setMultiRegion,
    setFormData,
    setImgObj,
    setDeleteUpdateItem,
    setFilterDropdown,
    setHistoryFilterDropdown,
    setIsLoadMore,
    setOpenMod,
    setChildFormData,
    setChildOpen,
    setOpenPreview,
    setReportChildOpen,
    setImageHeightWidth,
    setPermissions,
    setTokenType,
    setCopy,
    zipValidationMessage,
    setZipValidationMessage,

    // ================================
    handlePermissions,
    handleChildOpen,
    handleChildClose,
    handleReportChildOpen,
    handleReportChildClose,
    handleChildChange,
    handleChildSwitch,
    handleOpenbtn,
    handleClosebtn,
    handleCopyData,
    handleFilterChange,
    handleCheckboxChange,
    handleSelectAll,

    handleDeleteAll,
    handleChange,
    handleLogout,
    handleSwitch,
    handleSwitchUpdate,
    handleOpen,
    handleClose,
    handleFileInput,
    handleSelectMultiCountry,
    handleSelectMultiColor,
    handleReset,
    handleCopyToClipboard,
    selectedOptions,
    deleteUpdateYes,
    deleteUpdateTag,
    configData,
    setConfigData,
    // =========Truncate
    truncateString,
    handleImportClose,
    setEventDate,
    setMin, setMax

} = contextSlice.actions;

export default contextSlice.reducer;